import { Modal } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
  [data-modal-container] {
    display: flex;
    flex-direction: column;
    width: max(35%, 900px);
    padding-bottom: 0;
    max-height: calc(100% - 40px);
  }

  [data-modal-header] {
    padding: 8px 8px 0px;
  }
`;
